import instance from "./BaseApi";

// Get billing details (customer, payment methods, subscription)
export function getBillingDetails(payingCustomerId = null) {
  const params = payingCustomerId ? `?paying_customer_id=${payingCustomerId}` : '';
  return instance.request({
    url: `billing/details/${params}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// Get organisation's billing products (from admin-created BillingInfo)
export function getOrganisationProducts() {
  return instance.request({
    url: `billing/products/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// Activate subscription
export function activateSubscription(data) {
  return instance.request({
    url: `billing/activate-subscription/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

// Confirm subscription after 3D Secure authentication
export function confirmSubscription(data) {
  return instance.request({
    url: `billing/confirm-subscription/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

// Get paginated invoices
export function getInvoices(limit = 10, startingAfter = null, payingCustomerId = null) {
  const params = new URLSearchParams({ limit: limit.toString() });
  if (startingAfter) {
    params.append("starting_after", startingAfter);
  }
  if (payingCustomerId) {
    params.append("paying_customer_id", payingCustomerId);
  }
  
  return instance.request({
    url: `billing/invoices/?${params.toString()}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// Add payment method
export function addPaymentMethod(data) {
  return instance.request({
    url: `billing/add-payment-method/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

// Confirm payment method after 3D Secure authentication
export function confirmPaymentMethod(data) {
  return instance.request({
    url: `billing/confirm-payment-method/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function dismissBillingFailureNotice(data) {
  return instance.request({
    url: `billing/dismiss-failure-notice/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function retryInvoicePayment(data) {
  return instance.request({
    url: `billing/retry-invoice-payment/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

// Update billing details
export function updateBillingDetails(data) {
  return instance.request({
    url: `billing/update-details/`,
    method: "PUT",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

// Cancel subscription
export function cancelSubscription(payingCustomerId = null) {
  return instance.request({
    url: `billing/cancel-subscription/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: payingCustomerId ? { paying_customer_id: payingCustomerId } : {},
  });
}

// Preview subscription with tax
export function previewSubscription(data) {
  return instance.request({
    url: `billing/preview-subscription/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

// Get feature flag product details (price, etc.)
export function getFeatureFlagProduct(featureFlagReference) {
  return instance.request({
    url: `billing/feature-flag-product/${featureFlagReference}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}
